import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { usePostHog } from 'posthog-js/react';
import useAuthToken from '../hooks/useAuthToken';
import LoadingView from 'views/LoadingView';

interface Auth0ProtectedRouteProps {
  children: JSX.Element;
}

export default function Auth0ProtectedRoute(props: Auth0ProtectedRouteProps): JSX.Element {
  const { isAuthenticated, isLoading, loginWithRedirect, user } = useAuth0();
  const hasToken = useAuthToken();
  const posthog = usePostHog();

  // Identify user with PostHog when authenticated
  useEffect(() => {
    if (isAuthenticated && user?.email != null && user.email !== '') {
      posthog?.identify(user.email);
    }
  }, [isAuthenticated, user?.email, posthog]);

  useEffect(() => {
    if (isLoading || isAuthenticated) {
      return;
    }

    (async (): Promise<void> => {
      await loginWithRedirect({
        authorizationParams: {
          redirect_uri: `${window.location.origin}/react-callback`,
        },
      });
    })().catch((e) => console.error(e));
  }, [isLoading, isAuthenticated, loginWithRedirect]);

  return isAuthenticated && hasToken ? props.children : <LoadingView />;
}
